import { nanoid } from 'nanoid';
import { camelCase } from 'lodash';

export const NODE_ID_SEPARATOR = '-';

export const generateId = (len = 16): string => nanoid(len);

/**
 * Generate building block _id field.
 *
 * size = 9 -> ~19,000,000 ids needed to have a 1% probability of at least one collision
 */
export const generateElementId = (): string => nanoid(9);

/**
 * generate building block uiConfig.nodeProps.id field
 * @param id {string} building block _id field value
 * @param name {string} building block name field
 * @return {string}
 */
export const generateNodeId = (id: ReturnType<typeof generateElementId>, name: string): string =>
	`${camelCase(name).toLowerCase()}${NODE_ID_SEPARATOR}${id}`;

export const generateCardId = () => generateId(5);

export const generateCardEventId = () => generateId(5);

export const generateStepId = () => generateId(5);
